import "./adminFormField.css";
import { FieldError } from "../FieldError/FieldError";

export const AdminInput = ({
  label,
  name,
  error,
  hint,
  required,
  id,
  className = "",
  ...rest
}) => {
  const fieldId = id || name;
  return (
    <div className={`admin-field ${className}`}>
      {label && (
        <label htmlFor={fieldId} className="admin-field__label">
          {label}
          {required && <span className="admin-field__required">*</span>}
        </label>
      )}
      <input
        id={fieldId}
        name={name}
        className={`admin-field__control ${error ? "admin-field__control--error" : ""}`}
        aria-invalid={Boolean(error)}
        required={required}
        {...rest}
      />
      {hint && !error && <span className="admin-field__hint">{hint}</span>}
      <FieldError>{error}</FieldError>
    </div>
  );
};
